<!--
 * @Description: 重要度排序查询
 * @Author: maqinghe 
 * @Date: 2023年05月31日 15:26:15
-->
<template>
  <div class='importance-page atb-flex atb-flex-column'>
    <div class='container atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" ref="searchForm" :rules="rules" class="atb-input" :show-message="false" @keyup.enter.native="getList" @submit.native.prevent>
          <div class="query-where">
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover
                placement="bottom-start"
                width="420"
                popper-class="popper-tree declare-dep"
                @hide="handledHide"
                trigger="click">
                <!-- <el-input v-model="searchDep" placeholder="请输入部门名称搜索" clearable></el-input> -->
                <el-tree
                  :props="defaultProps"
                  :data="treeData"
                  show-checkbox
                  node-key='id'
                  ref="tree"
                  highlight-current
                  :default-expanded-keys="expandedData"
                  @check="handleCheckChange">
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item class="flex-form-item" label="上级">
              <selecter v-model="searchParam.SuperiorNo" placeholder="输入工号或姓名查询" :name="searchParam.superiorName"></selecter>
            </el-form-item>
            <el-form-item label="姓名">
              <!-- <selecter v-model="searchParam.WkNo" clearable @selecterData="getSelecterData"></selecter> -->
              <el-input v-model="searchParam.WkName" placeholder="姓名" clearable></el-input>
            </el-form-item>
            <el-form-item class="flex-form-item" label="状态">
              <common-select ref="status" v-model="searchParam.Status" :list="oecStatusList" optLabel="itemDesc" optValue="itemValue" placeholder="状态" clearable></common-select>
            </el-form-item>
          </div>
          <div class="query-operation">
            <el-form-item label="年份" prop="Year">
              <el-date-picker v-model="searchParam.Year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
            </el-form-item>
            <el-form-item label="期次" prop="Period">
              <common-select ref="period" v-model="searchParam.Period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" clearable></common-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="downloadTemplate" @click="exportMulti">批量导出</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          stripe
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="table"
          @cell-click="expandRow"
          :tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildrenList}"
        >
          <vxe-table-column type="seq" title="NO." min-width="120" width="220" tree-node></vxe-table-column>
          <vxe-table-column field="period" title="期次" width="100">
            <template #default="{ row }">
              <span>{{ row.year }}{{ periods[row.period] }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="department" title="部门" min-width="250"></vxe-table-column>
          <vxe-table-column field="wkName" width="150" title="姓名">
            <template #default="{ row }">
              <span class="name-col" @click="toPage(row)">{{row.wkName? row.wkName + "("+row.wkNo+")": row.wkNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="superior" width="150" title="上级">
            <template #default="{ row }">
              <span>{{row.superiorName? row.superiorName + "("+row.superiorNo+")": row.superiorNo}}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="configWkInfo" title="排序人" width="150"></vxe-table-column>
          <vxe-table-column field="score" title="总分" width="80"></vxe-table-column>
          <vxe-table-column field="sort" title="排名" width="80"></vxe-table-column>
          <vxe-table-column field="remark" title="备注" min-width="250">
            <template #default="{ row }">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.remark }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="80">
            <template #default="{ row }">
              <el-tag v-if="row.status === 0 || row.status === 10" type="unstart" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else-if="row.status === 40" type="complete" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
              <el-tag v-else type="ongoing" effect="dark">
                {{ statusMap[row.status] || '' }}
              </el-tag>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>
    <common-dialog ref="exportDialog" title="期次范围选择" width="530px" showClose :appendBody="true">
      <template slot="content">
        <exportComponent :param="exportParams"></exportComponent>
      </template>
    </common-dialog>
  </div>
</template>
<script>
  import _ from 'lodash';
  import { PERIOD_LIST, PERIODS, IMPORTANCE_STATE } from '@/utils/period-enum.js';

  export default {
    name: "ImportanceSearch",
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      exportComponent:()=>import('./export.vue'),
    },
    data() {
      return {
        currWkNo: '',
        searchParam: {
          WkNo: '',
          WkName: '',
          Status: '',
          SuperiorNo: '',
          Year: undefined,
          Period: undefined
        },
        tableData: [],
        periodList: PERIOD_LIST,
        periods: PERIODS,
        statusMap: IMPORTANCE_STATE,

        oecStatusList: [
          { "itemValue": "0", "itemDesc": "未填报" },
          { "itemValue": "10", "itemDesc": "已驳回" },
          { "itemValue": "20", "itemDesc": "已填报" },
          { "itemValue": "30", "itemDesc": "已审批" },
        ],
        depData:[],
        treeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        depList: [],
        checkId: "",
        department: '',
        copyTreeData: [],
        departmentNo: '',
        expandedData: [],
        rules: {
          Year: [{
            validator: false,
            trigger: 'blur',
          }],
          Period: [{
            validator: false,
            trigger: 'blur',
            type: 'number'
          }]
        }
      }
    },
    created() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.currWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
      this.getDep();
    },
    mounted() {
      this.getList();
    },
    computed: {
      exportParams() {
        return {
          loginWkNo: this.currWkNo,
          ...this.searchParam,
          year: this.searchParam.Year ? parseInt(this.searchParam.Year) : undefined,
          period: this.searchParam.Period || undefined,
          departmentNo: this.departmentNo
        }
      }
    },
    watch: {
      department: {
        handler(val){
          if(!val){
            this.departmentNo = "";
            this.$refs.tree && this.$refs.tree.setCheckedKeys([]);
          }
        },
        immediate:true
      }
    },
    activated() {
      this.getList();
    },
    methods: {
      async getDep() {
       await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then(res => {
          this.depList = res.data || [];     
            const obj = {};
            this.depList.forEach(v => {
            const objClone = _.cloneDeep(obj);
            objClone.id = v.id,
            objClone.code = v.code,
            objClone.label = v.displayName
           if (v.parentId === null) {
              this.expandedData.push(v.id);
              objClone.children = this.depList.filter(t => t.parentId === v.id);
              this.generateMenu(objClone.children);
              this.treeData.push(objClone);
              this.copyTreeData = _.cloneDeep(this.treeData);
            }
          });
        });
      },
      generateMenu(chs){
        chs.forEach(v => {
          v.label = v.displayName
          v.children = this.depList.filter(t => t.parentId === v.id)
          this.generateMenu(v.children);
        });
      },
      getSimpleCheckedNodes(store) {
        const checkedNodes = [];
        const traverse = function(node) {
          const childNodes = node.root ? node.root.childNodes : node.childNodes;
          childNodes.forEach(child => {
            if (child.checked) {
              checkedNodes.push(child.data);
            }
            if (child.indeterminate) {
              traverse(child);
            }
          });
        };
        traverse(store)
        return checkedNodes;
      },
      handleCheckChange(data, checked){
        this.selectNode = this.getSimpleCheckedNodes(this.$refs.tree.store);
        let code = [] , deptNmae = [];
        this.selectNode.forEach(t => {
          code.push(t.code);
          deptNmae.push(t.label);
        });
        this.departmentNo = code.join(",");
        this.department = deptNmae.join(",");
      },
      getChildrenMenu(depData){
        let depTree = [];
        depData.forEach(t => {
          if(t.label.indexOf(this.department) != -1){
          depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.treeData=depTree;
      },
      handledHide(){
        this.$nextTick(()=>{
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department = "";
          }
        });
      },
      setValid(valid) {
        if (valid) {
          this.rules.Year[0].validator = (rule, value, callback) => {
            if (value && !this.searchParam.Period) {
              this.$refs.searchForm.validateField('Period');
              callback();
            } else if (!value && this.searchParam.Period) {
              callback(new Error('"年份"为必填项'));
            } else if (!value && !this.searchParam.Period) {
              this.$refs.searchForm.clearValidate();
              callback()
            } else {
              callback()
            }
          }
          this.rules.Period[0].validator = (rule, value, callback) => {
            if (value && !this.searchParam.Year) {
              this.$refs.searchForm.validateField('Year');
              callback();
            } else if (!value && this.searchParam.Year) {
              callback(new Error('"期次"为必填项'));
            } else if (!value && !this.searchParam.Year) {
              this.$refs.searchForm.clearValidate();
              callback()
            } else {
              callback()
            }
          }
        } else {
          this.rules.Year[0].validator = false;
          this.rules.Period[0].validator = false;
        }
      },
      getList() {
        this.setValid(1);
        this.$refs['searchForm'].validate(async (valid, errors) => {
          if (valid) {
            this.tableData = [];
            let param = {
              ...this.searchParam,
              Year:  this.searchParam.Year || undefined,
              Period:  this.searchParam.Period || undefined,
              DepartmentNo: this.departmentNo
            };
            this.$ajax.get(this.$api.period.importanceSort.list, param).then((res) => {
              let resList = res.data.importantSort || [];
              resList = resList.map(p => {
                p.parentId = null;
                p.hasChild = p.isOrLeader ? true : false;
                return p;
              });
              this.tableData = resList;
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        });
      },
      loadChildrenList({ row }) {
        let param = {
          ParentWkNo: row.wkNo,
          Year: this.searchParam.Year || undefined,
          Period: this.searchParam.Period || undefined,
          departmentNo: this.departmentNo
        };
 
        return new Promise(resolve => {
          this.$ajax.get(this.$api.period.importanceSort.list, param).then((res) => {
            if (res.data.importantSort.length) {
              resolve(res.data.importantSort && res.data.importantSort.map(p => {
                p.parentId = row.id;
                p.hasChild = p.isOrLeader ? true : false;
                return p
              }));
            } else {
              row.hasChild = false;
              resolve(row);
            }
          });
        });
      },
      toPage(row) {
        let configWkInfo = row.configWkInfo || '';
        let configWkNo = configWkInfo.split('(')[1] || '';
        configWkNo = configWkNo.replace(')', '');
        this.$router.push({path: '/period/importance-search/detail', query: { wkNo: configWkNo, year: row.year || '', period: row.period, search: '1' }});
      },
      // eslint-disable-next-line no-unused-vars
      expandRow({row, triggerTreeNode}) {
        if (triggerTreeNode) return;
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.table.updateData(this.tableData);
      },

      // 导出
      exportExcel() {
        this.setValid(1);
        this.$refs['searchForm'].validate(async (valid, errors) => {
          if (valid) {
            this.$ajax.get(this.$api.period.importanceSearch.export, this.exportParams, {ignore: true, responseType: 'blob'}).then((res) => {
              if (res.data.type == 'application/json') {
                var reader = new FileReader();
                reader.onload = () => {
                  var content = reader.result;//内容就在这里
                  let json = JSON.parse(content)
                  this.$message.error(json.message)
                };
                reader.readAsText(res.data);
              } else {
                const filename = '重要度排序查询'
                const filetype = 'xlsx'
                let data = res.data;
                let url = window.URL.createObjectURL(data)
                let a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.download = filename + '.' + filetype
                a.click()
                window.URL.revokeObjectURL(url)
              }
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        })
      },
      exportMulti(){
        this.$refs.exportDialog.show();
      },
    },
  }
</script>
<style scoped lang='scss'>
  .importance-page {
    height: 100%;

    .search {
      .atb-input {
        display: flex;
        flex-direction: column;
        .query-where {
          display: flex;
          .flex-form-item {
            display: flex;
            flex: 1;
            margin-bottom: 12px;
          }
          ::v-deep.el-form-item__content {
            flex: 1;
            .el-select, .el-autocomplete, .el-date-editor {
              width: 100%;
            }
          }
        }
        .query-operation {
          display: flex;
        }
      }
    }
    .container {
      padding: 24px;
      flex: 1;
  
      ::v-deep .atb-table {
        .main-row {
          .vxe-cell {
            padding: 0;
          }
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: left;
      .sub-content{
        text-align: center;
      }
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: right;
    }
  }
 
  .name-col {
    cursor: pointer;
    color: $--color-primary;
  }
</style>